import "jQuery";
import {breakpoints} from './responsive';

"use strict";

(function($) {

    var map;
    var activeMarker;

    $(document).ready(function() {

        breakpoints.init();

        let $map = $('#map');
        let lat, lng, zoom;
        if(breakpoints.is('bp_min_md')) {
            lat = parseFloat($map.data('lat'));
            lng = parseFloat($map.data('lng'));
            zoom = parseInt($map.data('zoom'));
        } else {
            lat = parseFloat($map.data('lat-mobile'));
            lng = parseFloat($map.data('lng-mobile'));
            zoom = parseInt($map.data('zoom-mobile'));
        }
        console.log(lat);
        console.log(lng);

        map = L.map('map',{
            scrollWheelZoom: false,
            doubleClickZoom: false,
            zoomControl: false,
            dragging: !L.Browser.mobile,
            tap: !L.Browser.mobile
        }).setView([lat, lng], zoom);

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            maxZoom: 18,
            id: 'camelcode/ckic4nbc40sdx19qr7sv2ks47',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoiY2FtZWxjb2RlIiwiYSI6ImNraWM0a3FsczE1cjAyemxjNmc2ZjV3NGkifQ.EobNlFsnWkVTbzCgs-9z5Q',
            edgeBufferTiles: 1,
        }).addTo(map);

        var MarkerIcon = L.Icon.extend({
            options: {
                iconSize:     [22, 18],
                iconAnchor:   [11, 9],
            }
        });

        if($map.hasClass('use-page-markers')) {
            if($map.data('marker-image')) {
                var markerDefaultIcon = new MarkerIcon({iconUrl: $map.data('marker-image')});
            }
            if($map.data('marker-active-image')) {
                var markerActiveIcon = new MarkerIcon({iconUrl: $map.data('marker-active-image')});
            }
            if($map.data('marker-hover-image')) {
                var markerHoverIcon = new MarkerIcon({iconUrl: $map.data('marker-hover-image')});
            }
            $('.is-marker').each(function() {
                let $marker_elmt = $(this);
                let lat = $marker_elmt.data('lat');
                let lng = $marker_elmt.data('lng');
                if(lat === '' || lng === '') {
                    return;
                }
                let name = $marker_elmt.find('.name').text();
                let office_id = $marker_elmt.data('office-id');
                let marker = L.marker([lat, lng], {icon: markerDefaultIcon}).addTo(map);
                marker.on('click', function(e) {
                    marker.setIcon(markerActiveIcon);
                });
                marker.on('click', function(e) {
                    if(breakpoints.is('bp_min_md')) {
                        if (activeMarker) {
                            activeMarker.setIcon(markerDefaultIcon);
                        }
                        marker.setIcon(markerActiveIcon);
                        activeMarker = marker;
                        $('.representative-wrapper').removeClass('active');
                        $('.team-members').removeClass('active');
                        $('.aside-col').addClass('active');
                        $('.regions-details').removeClass('active');
                        $marker_elmt.addClass('active').find('.location').text(name);
                        $('.team-members.office-' + office_id).addClass('active');
                    }
                });
                marker.on('mouseover', function(e) {
                    if(marker !== activeMarker) {
                        marker.setIcon(markerHoverIcon);
                    }
                });
                marker.on('mouseout', function(e) {
                    if(marker !== activeMarker) {
                        marker.setIcon(markerDefaultIcon);
                    }
                });
            });
            $('.map-nav').click(function() {
                if(activeMarker) {
                    activeMarker.setIcon(markerDefaultIcon);
                }
            });
        }

        $('.map-nav').click(function() {
            $('.representative-wrapper.active').removeClass('active');
            $('.team-members.active').removeClass('active');
            $('.aside-col').removeClass('active');
            $('.regions-details').addClass('active');
            let dir = $(this).hasClass('nav-next') ? 'next' : 'prev';
            let $active_offices = $('.offices.active');
            let $new_offices;
            if(dir === 'prev') {
                $new_offices = $active_offices.nextAll('.offices:first');
                if($new_offices.length <= 0) {
                    $new_offices = $('.offices').first();
                }
            } else {
                $new_offices = $active_offices.prevAll('.offices:first');
                if($new_offices.length <= 0) {
                    $new_offices = $('.offices').last();
                }
            }
            if($new_offices.length > 0) {
                $new_offices.addClass('active');
                $active_offices.removeClass('active');
            }
            update_map_active_center();
        });
    });

    function update_map_active_center() {
        let $active_offices = $('.offices.active');
        let lat, lng, zoom;
        if(breakpoints.is('bp_min_md')) {
            lat = $active_offices.data('lat');
            lng = $active_offices.data('lng');
            zoom = $active_offices.data('zoom');
        } else {
            lat = $active_offices.data('lat-mobile');
            lng = $active_offices.data('lng-mobile');
            zoom = $active_offices.data('zoom-mobile');
        }

        map.flyTo([lat, lng], zoom, {
            animate: true,
            duration: 2
        });
    }

    // var map;
    // var activeMarker;
    // var marker_image;
    // var marker_active_image;
    // var marker_hover_image;

    // window.initMap = function(){
    //     let $map = $('#map');
    //     map = new google.maps.Map($map.get(0), {
    //         center: {
    //             lat: parseFloat($map.data('lat')),
    //             lng: parseFloat($map.data('lng'))
    //         },
    //         zoom: parseInt($map.data('zoom')),
    //         zoomControl: false,
    //         scaleControl: false,
    //         scrollwheel: false,
    //         disableDoubleClickZoom: true,
    //         disableDefaultUI: true,
    //         styles: map_styles
    //     });

        // if($map.hasClass('use-page-markers')) {
        //     if($map.data('marker-image')) {
        //         marker_image = new google.maps.MarkerImage($map.data('marker-image'), null, null, null, new google.maps.Size(22,18));
        //     }
        //     if($map.data('marker-active-image')) {
        //         marker_active_image = new google.maps.MarkerImage($map.data('marker-active-image'), null, null, null, new google.maps.Size(22,18));
        //     }
        //     if($map.data('marker-hover-image')) {
        //         marker_hover_image = new google.maps.MarkerImage($map.data('marker-hover-image'), null, null, null, new google.maps.Size(22,18));
        //     }
        //     $('.is-marker').each(function() {
        //         let $marker_elmt = $(this);
        //         let lat = $marker_elmt.data('lat');
        //         let lng = $marker_elmt.data('lng');
        //         let name = $marker_elmt.find('.name').text();
        //         let office_id = $marker_elmt.data('office-id');
        //         var marker = new google.maps.Marker({position: {lat: lat, lng: lng}, map: map, icon: marker_image});
        //         google.maps.event.addListener(marker, 'click', function() {
        //             if(breakpoints.is('bp_min_md')) {
        //                 if (activeMarker) {
        //                     activeMarker.setIcon(marker_image);
        //                 }
        //                 marker.setIcon(marker_active_image);
        //                 activeMarker = marker;
        //                 $('.representative-wrapper').removeClass('active');
        //                 $('.team-members').removeClass('active');
        //                 $('.aside-col').addClass('active');
        //                 $('.regions-details').removeClass('active');
        //                 $marker_elmt.addClass('active').find('.location').text(name);
        //                 $('.team-members.office-' + office_id).addClass('active');
        //             }
        //         });
        //         google.maps.event.addListener(marker, 'mouseover', function() {
        //             if(marker !== activeMarker) {
        //                 marker.setIcon(marker_hover_image);
        //             }
        //         });
        //         google.maps.event.addListener(marker, 'mouseout', function() {
        //             if(marker !== activeMarker) {
        //                 marker.setIcon(marker_image);
        //             }
        //         });
        //     });
        //     $('.map-nav').click(function() {
        //         if(activeMarker) {
        //             activeMarker.setIcon(marker_image);
        //         }
        //     });
        // }
        // google.maps.event.addListener(map, 'click', function() {
        //     if(activeMarker) {
        //         activeMarker.setIcon(marker_image);
        //     }
        //     activeMarker = null;
        //     $('.representative-wrapper').removeClass('active');
        //     $('.team-members').removeClass('active');
        //     $('.aside-col').removeClass('active');
        //     $('.regions-details').addClass('active');
        // });
    // }
    //
    // $(document).ready(function() {
    //
    //     breakpoints.init();

        // $('.map-nav').click(function() {
        //     $('.representative-wrapper.active').removeClass('active');
        //     $('.team-members.active').removeClass('active');
        //     $('.aside-col').removeClass('active');
        //     $('.regions-details').addClass('active');
        //     let dir = $(this).hasClass('nav-next') ? 'next' : 'prev';
        //     let $active_offices = $('.offices.active');
        //     let $new_offices;
        //     if(dir === 'prev') {
        //         $new_offices = $active_offices.nextAll('.offices:first');
        //         if($new_offices.length <= 0) {
        //             $new_offices = $('.offices').first();
        //         }
        //     } else {
        //         $new_offices = $active_offices.prevAll('.offices:first');
        //         if($new_offices.length <= 0) {
        //             $new_offices = $('.offices').last();
        //         }
        //     }
        //     if($new_offices.length > 0) {
        //         $new_offices.addClass('active');
        //         $active_offices.removeClass('active');
        //     }
        //     update_map_active_center();
        // });
    // });
    //
    // function update_map_active_center() {
    //     let $active_offices = $('.offices.active');
    //     let lat = $active_offices.data('lat');
    //     let lng = $active_offices.data('lng');
    //     let zoom = $active_offices.data('zoom');
    //     panPath = [];
    //     panQueue = [];
    //     panTo(lat, lng);
    //     // setTimeout(function(zoom) {
    //         map.setZoom(zoom);
    //     // }, 250, zoom);
    // }


    // var panPath = [];   // An array of points the current panning action will use
    // var panQueue = [];  // An array of subsequent panTo actions to take
    // var STEPS = 50;     // The number of steps that each panTo action will undergo
    //
    // function panTo(newLat, newLng) {
    //     if (panPath.length > 0) {
    //         // We are already panning...queue this up for next move
    //         panQueue.push([newLat, newLng]);
    //     } else {
    //         // Lets compute the points we'll use
    //         panPath.push("LAZY SYNCRONIZED LOCK");  // make length non-zero - 'release' this before calling setTimeout
    //         var curLat = map.getCenter().lat();
    //         var curLng = map.getCenter().lng();
    //         var dLat = (newLat - curLat)/STEPS;
    //         var dLng = (newLng - curLng)/STEPS;
    //
    //         for (var i=0; i < STEPS; i++) {
    //             panPath.push([curLat + dLat * i, curLng + dLng * i]);
    //         }
    //         panPath.push([newLat, newLng]);
    //         panPath.shift();      // LAZY SYNCRONIZED LOCK
    //         setTimeout(doPan, 20);
    //     }
    // }

    // function doPan() {
    //     var next = panPath.shift();
    //     if (next != null) {
    //         // Continue our current pan action
    //         map.panTo( new google.maps.LatLng(next[0], next[1]));
    //         setTimeout(doPan, 20 );
    //     } else {
    //         // We are finished with this pan - check if there are any queue'd up locations to pan to
    //         var queued = panQueue.shift();
    //         if (queued != null) {
    //             panTo(queued[0], queued[1]);
    //         } else {
    //             console.log('FINISH!');
    //
    //         }
    //     }
    // }
    //
    // var map_styles = [
    //     {
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "color": "#f5f5f5"
    //             }
    //         ]
    //     },
    //     {
    //         "elementType": "geometry.fill",
    //         "stylers": [
    //             {
    //                 "color": "#00a5db"
    //             }
    //         ]
    //     },
    //     {
    //         "elementType": "labels",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "elementType": "labels.icon",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //             {
    //                 "color": "#616161"
    //             }
    //         ]
    //     },
    //     {
    //         "elementType": "labels.text.stroke",
    //         "stylers": [
    //             {
    //                 "color": "#f5f5f5"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "administrative",
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "administrative.land_parcel",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "administrative.land_parcel",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //             {
    //                 "color": "#bdbdbd"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "administrative.neighborhood",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "poi",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "poi",
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "color": "#eeeeee"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "poi",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //             {
    //                 "color": "#757575"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "poi.park",
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "color": "#e5e5e5"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "poi.park",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //             {
    //                 "color": "#9e9e9e"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "road",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "road",
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "color": "#ffffff"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "road",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "road.arterial",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //             {
    //                 "color": "#757575"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "road.highway",
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "color": "#dadada"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "road.highway",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //             {
    //                 "color": "#616161"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "road.local",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //             {
    //                 "color": "#9e9e9e"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "transit",
    //         "stylers": [
    //             {
    //                 "visibility": "off"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "transit.line",
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "color": "#e5e5e5"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "transit.station",
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "color": "#eeeeee"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "water",
    //         "elementType": "geometry",
    //         "stylers": [
    //             {
    //                 "color": "#c9c9c9"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "water",
    //         "elementType": "geometry.fill",
    //         "stylers": [
    //             {
    //                 "color": "#82c6e2"
    //             }
    //         ]
    //     },
    //     {
    //         "featureType": "water",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //             {
    //                 "color": "#9e9e9e"
    //             }
    //         ]
    //     }
    // ];

})( jQuery );